export const financialRoutesHandler = (entity: string): string =>
  `${entity}${entity !== 'accounting' ? '/financial' : ''}`;
